import React from "react";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";

const UserGuides = () => (
    <Panel>
        <PanelBody>
            <h3>Guides - PDF files</h3>
            <ul>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerUserGuide.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                        Full user guide
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerRegistrationGuide.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                        Registration guide
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerFarmAccountGuide.pdf`} rel="noopener noreferrer" target="_blank">
                        Farm account guide
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/fm/OverseerPublishingGuide.pdf`} rel="noopener noreferrer" target="_blank">
                        Guide to publishing and regulatory compliance
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerBlocks.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                        How to set up blocks in Overseer
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/OverseerWetlandGuide.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                        Wetland photos and definitions
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/2019DecFeatureGuide.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                        Comparison tool and irrigation of blocks - guidance
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/FarmGroupsGuide.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                        Farm groups and aggregated reporting
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://docs.overseer.org.nz/${process.env.REACT_APP_PRODUCT}/SimplifyAnalyses.pdf`} target="_blank" rel="noopener noreferrer" id="lnk-open-guide">
                        Simplify analyses - merge blocks
                    </a>
                </li>
            </ul>
            <h3>Videos - Youtube</h3>
            <ul>
                <li className="u-mt-sm">
                    <a href={`https://www.youtube.com/watch?v=8tXssPDFNpA`} target="_blank" rel="noopener noreferrer" id="lnk-open-registration-video">
                        Registration guide (video 2 min)
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://www.youtube.com/watch?v=TxWLriTuDaU`} target="_blank" rel="noopener noreferrer" id="lnk-open-registration-video">
                        Farm accounts guide (video 2.45 min)
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://www.youtube.com/watch?v=DsyujHR0v_Y`} target="_blank" rel="noopener noreferrer" id="lnk-open-registration-video">
                        Organisations guide (video 2.11 min)
                    </a>
                </li>
                <li className="u-mt-sm">
                    <a href={`https://www.youtube.com/watch?v=izu5hiiwY-Q&t=2s`} target="_blank" rel="noopener noreferrer" id="lnk-open-registration-video">
                        Uploading XML farm files (video 2.22 min)
                    </a>
                </li>
            </ul>
        </PanelBody>
    </Panel>
);

export default UserGuides;
